import { useState, useEffect } from "react";
import { Clock, X, LogOut, UserPlus } from "lucide-react";
import { Button } from "./ui/button";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const DemoBanner = () => {
  const { isDemo, demoStatus, refreshDemoStatus, endDemo } = useAuth();
  const navigate = useNavigate();
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (isDemo && demoStatus) {
      setTimeRemaining(Math.round(demoStatus.minutes_remaining || 30));
    }
  }, [isDemo, demoStatus]);

  // Countdown timer
  useEffect(() => {
    if (!isDemo || timeRemaining === null) return;

    const interval = setInterval(() => {
      setTimeRemaining((prev) => {
        if (prev <= 0) {
          clearInterval(interval);
          endDemo();
          navigate("/");
          return 0;
        }
        return prev - 1/60; // Decrease by 1 second (1/60 of a minute)
      });
    }, 1000);

    // Refresh demo status every 5 minutes
    const refreshInterval = setInterval(() => {
      refreshDemoStatus();
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(interval);
      clearInterval(refreshInterval);
    };
  }, [isDemo, timeRemaining, endDemo, navigate, refreshDemoStatus]);

  if (!isDemo || dismissed) return null;

  const minutes = Math.floor(timeRemaining || 0);
  const isLowTime = minutes <= 5;

  const handleSignUp = () => {
    endDemo();
    navigate("/register");
  };

  return (
    <div className={`fixed top-0 left-0 right-0 z-50 py-2 px-4 flex items-center justify-between ${
      isLowTime ? "bg-red-600" : "bg-amber-500"
    } text-white shadow-lg`}>
      <div className="flex items-center gap-3">
        <Clock className="w-4 h-4" />
        <span className="text-sm font-medium">
          Demo Mode - {minutes} min{minutes !== 1 ? "s" : ""} remaining
        </span>
        <span className="hidden sm:inline text-xs opacity-80">
          • Emails disabled • PDFs watermarked
        </span>
      </div>
      
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant="secondary"
          className="h-7 text-xs bg-white text-gray-800 hover:bg-gray-100"
          onClick={handleSignUp}
        >
          <UserPlus className="w-3 h-3 mr-1" />
          Sign Up Free
        </Button>
        <Button
          size="sm"
          variant="ghost"
          className="h-7 text-xs text-white hover:bg-white/20"
          onClick={() => {
            endDemo();
            navigate("/");
          }}
        >
          <LogOut className="w-3 h-3 mr-1" />
          Exit
        </Button>
        <button
          onClick={() => setDismissed(true)}
          className="p-1 hover:bg-white/20 rounded"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default DemoBanner;
